export const CALENDARS_FETCH_ONE = 'CALENDARS_FETCH_ONE';
export const CALENDARS_FETCH_ALL = 'CALENDARS_FETCH_ALL';
export const CALENDARS_CREATE_ONE = 'CALENDARS_CREATE_ONE';
export const CALENDARS_UPDATE_ONE = 'CALENDARS_UPDATE_ONE';
export const CALENDARS_DELETE_ONE = 'CALENDARS_DELETE_ONE';
